import { render, staticRenderFns } from "./trans-summary-info.html?vue&type=template&id=44f4185c&scoped=true&external"
import script from "./trans-summary-info.js?vue&type=script&lang=js&external"
export * from "./trans-summary-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-summary-info.scss?vue&type=style&index=0&id=44f4185c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4185c",
  null
  
)

export default component.exports